/** keyRef / epoch helpers — `bk1:<identityId>:<epoch>` (F4, ADR-12). Time is always an argument. */

export const EPOCH_MICROS = 604_800_000_000; // 7 days in µs

export const epochOf = (micros: number): number => {
  if (!Number.isSafeInteger(micros) || micros < 0) throw new Error("bad micros");
  return Math.floor(micros / EPOCH_MICROS);
};

export const makeKeyRef = (identityId: string, micros: number): string =>
  `bk1:${identityId}:${epochOf(micros)}`;

export function parseKeyRef(ref: string): { identityId: string; epoch: number } {
  if (!ref.startsWith("bk1:")) throw new Error("keyRef: missing bk1: prefix");
  const rest = ref.slice(4);
  const cut = rest.lastIndexOf(":");
  if (cut < 0) throw new Error("keyRef: missing epoch separator");
  const identityId = rest.slice(0, cut);
  if (identityId.length === 0) throw new Error("keyRef: empty identityId");
  const epochStr = rest.slice(cut + 1);
  if (!/^[0-9]+$/.test(epochStr)) throw new Error("keyRef: epoch must be a base-10 integer");
  const epoch = Number(epochStr);
  if (!Number.isSafeInteger(epoch)) throw new Error("keyRef: epoch out of range");
  return { identityId, epoch };
}
